export default {
      id: "modal-fail-usage",
      viewBox: "0 0 38 38",
      url: "/" + "images/icons.3.109.2.svg#modal-fail-usage",
      toString: function () {
        return this.url;
      }
    }